import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {IdexService} from '../../idex.service';
import { PasswordStrengthComponent } from '../../shared/password-strength/password-strength';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-setpassword-dialog',
  templateUrl: './setpassword-dialog.component.html',
  styleUrls: ['./setpassword-dialog.component.css']
})
export class SetpasswordDialogComponent implements OnInit {
   @ViewChild(PasswordStrengthComponent) pwdStrength: PasswordStrengthComponent;
   newpass: string;
   conpass: string;
   visible = false;
   visibleC = false;
   private username: string;
   private fullname: string;
   minLength: number;
   maxLength: number;
   newError: string;
   loading: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, public service: IdexService,
              private dialogRef: MatDialogRef<SetpasswordDialogComponent>,
              private translate: TranslateService) {
     if (data) {
        this.username = data._user.email;
        this.fullname = data._user.name;
     } else {
        this.username = '';
        this.fullname = '';
     }
  }

  ngOnInit() {
     this.service.get('api/password-policy')
        .subscribe(data => {
           this.minLength = data.minLength;
           this.maxLength = data.maxLength;
        });
  }

   ok() {
      this.dialogRef.close(true);
   }

   eval(): void {
      if (this.newpass) {
         this.pwdStrength.eval(this.newpass, this.username, this.fullname);
      }
   }

   setPassword() {
      this.service.setPassword(this.newpass)
         .subscribe(data => {
            this.dialogRef.close();
            this.data.translate.get('alert.setpassword').subscribe(s => {
               this.data.toast.success(s);
            });
         }, error => {
            let e = error;
            try {
               e = JSON.parse(error);
            } catch {}
            if (e.status === 401) {
               this.translate.get('timeout').subscribe(s => {
                  this.data.toast.error(s);
               });
            } else if (e.status === 403) {
               this.data.toast.error(e.message);
               this.newError = e.message;
               this.loading = false;
            } else {
               this.data.toast.error(e.message);
               this.newError = e.message;
               this.loading = false;
            }
         });
   }
}
